import { TRACK_COLLECTION_CLICKED } from '../types';
export const trackCollectionClicked = options => {
  return {
    type: TRACK_COLLECTION_CLICKED,
    payload: options
  };
};